import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-usages',
    templateUrl: './usages.component.html',
    styleUrls: ['./usages.component.scss']
})
export class UsagesComponent implements OnInit {
    @Input() entities: any;
    @Input() APIs: any;

    constructor() {
    }

    ngOnInit() {
    }

    getIconClass(type) {
        switch (type) {
            case 'API':
                return 'fa fa-table';
            case 'BUSINESSLOGIC':
                return 'fa fa-link';
            case 'SQLQUERY':
                return 'fa fa-database';
            case 'TESTSUITE':
                return 'fa fa-check-circle';
        }
    }

}
